import { useState } from 'react';
import {
  Pill,
  SectionHead,
  StatusBar,
  StatusLabel,
  TableWrap,
  Td,
  Th,
  Tr,
} from '../components/DataTable';
import { PageHeader } from '../components/PageHeader';
import { useAeoPages, useTools } from '../lib/queries';

export function AeoPagesList() {
  const tools = useTools();
  const [toolId, setToolId] = useState<string | undefined>();
  const pages = useAeoPages(toolId);

  const selectedSlug = tools.data?.find((t) => t.id === toolId)?.slug;

  return (
    <div>
      <PageHeader
        breadcrumb="Tool Factory · AEO pages"
        title="AEO pages"
        subtitle="Answer-engine optimization pages emitted by each tool. Pick a tool to view its published surface."
        actions={
          <select
            className="rounded-md border border-border bg-card px-3 py-[8px] font-heading text-[12px] font-medium text-foreground transition-colors hover:bg-secondary/60"
            value={toolId ?? ''}
            onChange={(e) => setToolId(e.target.value || undefined)}
          >
            <option value="">Select a tool…</option>
            {tools.data?.map((t) => (
              <option key={t.id} value={t.id}>
                {t.slug}
              </option>
            ))}
          </select>
        }
      />

      <SectionHead
        title={selectedSlug ? `Pages for ${selectedSlug}` : 'All AEO pages'}
        meta={toolId ? `${pages.data?.length ?? 0} pages` : 'Pick a tool above'}
      />

      <TableWrap>
        <thead>
          <tr>
            <Th>Kind</Th>
            <Th>URL</Th>
            <Th>Title</Th>
            <Th>Status</Th>
            <Th>Published</Th>
          </tr>
        </thead>
        <tbody>
          {!toolId ? (
            <Tr hoverable={false}>
              <Td>
                <span className="text-foreground/50">Pick a tool above to see its AEO pages.</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
            </Tr>
          ) : (pages.data ?? []).length === 0 ? (
            <Tr hoverable={false}>
              <Td>
                <span className="text-foreground/50">No AEO pages for this tool.</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
              <Td>
                <span className="text-foreground/30">—</span>
              </Td>
            </Tr>
          ) : (
            pages.data?.map((p) => (
              <Tr key={p.id}>
                <Td>
                  <Pill>{p.kind}</Pill>
                </Td>
                <Td>
                  <code className="font-mono text-[12px] text-foreground/85">{p.url_path}</code>
                </Td>
                <Td>
                  <span className="font-medium text-[13.5px]">{p.title}</span>
                </Td>
                <Td>
                  <StatusLabel status={p.status} />
                </Td>
                <Td>
                  {p.updated_at ? (
                    <span className="font-mono text-[12px] text-foreground/65">
                      {new Date(p.updated_at).toLocaleDateString()}
                    </span>
                  ) : (
                    <span className="text-foreground/30">—</span>
                  )}
                </Td>
              </Tr>
            ))
          )}
        </tbody>
      </TableWrap>

      <StatusBar
        left={
          toolId ? `${pages.data?.length ?? 0} pages` : `${tools.data?.length ?? 0} tools available`
        }
        right="tools.holdengr.com"
      />
    </div>
  );
}
